import { useRef } from "react"
import Style from "./style"

import DefaultSlideModal from "shared/ui/DefaultSlideModal"
import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"

import usePutAccont from "entity/account/usePutAccont"

const NicknameModal = ({ name, nickname, closeEvent }) => {
    const nameRef = useRef()
    const nicknameRef = useRef()

    const [putAccount] = usePutAccont(nameRef, nicknameRef)

    return (
        <DefaultSlideModal title="정보 수정" closeEvent={closeEvent}>
            <Style.Content>
                <DefaultInput title="이름" placeholder={"이름"} defaultValue={name} required inputRef={nameRef} />
                <DefaultInput title="닉네임" placeholder={"닉네임"} defaultValue={nickname} irequired inputRef={nicknameRef} />
            </Style.Content>
            <DefaultButton clickEvent={putAccount}>수정하기</DefaultButton>
        </DefaultSlideModal>
    )
}

export default NicknameModal